/*
 * @Description: cms管理 router
 * @Author: yy
 * @LastEditors: yangyang yyangacom@163.com
 * @Date: 2019-04-16 11:48:56
 * @LastEditTime: 2023-11-20 09:18:17
 */

import React from 'react';
import Layout from '../../components/Layout';

import Brand from './Brand'
import Report from './Report'
import Article from './Article'
import Briefing from './Briefing';
import BrandNew from './BrandNew';

export default {
  path: '/new-cms',
  async action(...res) {
    return //console.log( )
  },
  children: [
    {
      path: '/',
      action () {
        return {
          title: '品牌管理',
          component: <Layout>
            <BrandNew />
          </Layout>
        }
      }
    },
    {
      path: '/old',
      action () {
        return {
          title: '品牌管理-old',
          component: <Layout>
            <Brand />
          </Layout>
        }
      }
    },
    {
      path: '/article',
      action () {
        return {
          title: '文章管理',
          component: <Layout>
            <Article />
          </Layout>
        }
      }
    },
    {
      path: '/report',
      action () {
        return {
          title: '研究报告管理',
          component: <Layout>
            <Report />
          </Layout>
        }
      }
    },
    {
      path: '/briefing',
      action () {
        return {
          title: '简报账号管理',
          component: <Layout>
            <Briefing />
          </Layout>
        }
      }
    }
  ]
};



// WEBPACK FOOTER //
// src/routes/cms/index.js